export default {
  index: {
    title: 'Index'
  },

  about: 'About',

  introduction: {
    title: 'Introduction',
    detail: {
      history: { title: 'History' },
      'current-situation': { title: 'Present Day' }
    }
  },

  founder: {
    title: 'The founder, Master Jing Kong',
  },

  chairman: {
    title: 'The Chairman, Venerable Mi Bao',
  },

  library: {
    title: 'Huazang Lecture Hall Library',
  },

  contact: {
    title: 'Contact Us',
    detail: {
      heading: {
        contacts: 'Contacts'
      },
      label: {
        name: 'Name',
        address: 'Address',
        telephone: 'Tel',
        email: 'E-Mail',
        fax: 'Fax',
        'fax-hotline-for-dharma-application': 'Fax hotline for dharma application',
        'tax-id-number': 'Tax ID number',
        url: 'Website'
      },
      value: {
        name: 'The Corporate Body of the Buddha Educational Foundation',
        address: '3F., No. 55, Sec. 1, Hangzhou S. Rd., Zhongzheng Dist., Taipei City, 100022, Taiwan (R.O.C.)',
        telephone: '+886-2-23951198',
        email: 'budaedu@budaedu.org',
        fax: '+886-2-23913415',
        'fax-hotline-for-dharma-application': '+886-2-23965959',
        'tax-id-number': '21102881',
        url: 'https://www.budaedu.org'
      }
    }
  },

  donation: {
    title: 'Support Donation',
    heading: {
      'credit-card': 'Credit card',
      'wire-transfer': {
        domestic: 'Domestic wire transfer',
        international: 'International wire transfer'
      }
    }
  },

  traffic: {
    title: 'Traffic Information',
    text: {
      name: 'The Corporate Body of the Buddha Educational Foundation',
      address: 'No. 55, Sec. 1, Hangzhou S. Rd., Zhongzheng Dist., Taipei City, 100022, Taiwan (R.O.C.)'
    },
    button: {
      'google-map': { label: 'Open in Google Maps' }
    }
  },

  recruitment: {
    title: 'Staff and volunteer recruitment',
  },

  announcement: 'Announcement',

  bulletin: {
    title: 'Bulletin'
  },

  'course-cancel-bulletin': {
    title: 'Class Suspension Bulletin',
    table: {
      header: {
        date: 'Date',
        course: 'Course',
        lecturer: 'Lecturer'
      }
    }
  },

  sidelight: {
    title: 'Sidelight',
    list: {
      'search-bar': {
        'category-selector': { hint: 'Category' },
        'year-selector': { hint: 'Year' },
        'search-button': { label: 'Search' }
      },
      button: {
        'more-info': { label: 'More Info' }
      }
    },
    detail: {
      heading: {
        'photos-compressed-file': 'Photos Compressed File',
        photos: 'Photo',
        videos: 'Video'
      },
      'instruction-text': {
        'click-icon-to-download-file': 'Click icon to download file',
        'click-thumbnail-to-enlarge-photo': 'Click thumbnail to enlarge photo'
      }
    }
  },

  weekly: {
    title: 'Buddha Education Weekly',
    list: {
      'search-bar': {
        'year-selector': {
          hint: 'Year',
          option: { label: '{year}' }
        },
        'month-selector': {
          hint: 'Month',
          option: { label: '{month}' }
        },
        'search-button': { label: 'Search' }
      },
      button: {
        'subscribe-or-unsubscribe': { label: 'Subscribe or unsubscribe' },
        read: { label: 'Read' }
      }
    }
  },

  monthly: {
    title: 'Buddha Education Monthly',
    list: {
      'search-bar': {
        'year-selector': {
          hint: 'Year',
          option: { label: '{year}' }
        },
        'month-selector': {
          hint: 'Month',
          option: { label: '{month}' }
        },
        'search-button': { label: 'Search' }
      },
      button: {
        read: { label: 'Read' }
      }
    }
  },

  activitie: 'Activitie',

  course: {
    title: 'Course',
    list: {
      latest: {
        title: 'Latest courses',
        button: {
          introduction: { label: 'Introduction' }
        }
      },
      today: { title: 'Today\'s course' },
      all: { title: 'All course' },
      review: { title: 'Course review' },
      table: {
        header: {
          time: 'Time',
          course: 'Course',
          lecturer: 'Lecturer',
          place: 'Place',
          'start-date': 'Start Date',
          'end-date': 'End Date',
          livestream: 'Live stream',
          series: 'Video or audio',
          remark: 'Note'
        }
      },
      button: {
        livestream: { label: 'Live' },
        'video-or-audio': { label: 'Video or audio' }
      },
      message: {
        'have-not-started-yet': 'Have not started yet',
        none: 'None'
      }
    },
    detail: {
      title: 'Introduction',
      button: {
        'view-more': { label: 'View more courses' }
      },
      label: {
        name: 'Name',
        time: 'Time',
        place: 'Location',
        lecturer: 'Lecturer',
        introduction: 'Introduction',
        livestream: 'Live stream'
      },
      message: {
        'has-not-started-yet': 'The course has not started yet. ',
        'has-ended': 'The course has ended.',
        none: 'None'
      }
    }
  },

  lecturer: {
    detail: {
      title: 'Lecturer introduction',
      label: {
        name: 'Name',
        introduction: 'Introduction'
      }
    }
  },

  academy: {
    title: 'Holiday Buddhist Academy',
    detail: {
      'cohort-selector': { hint: 'Please select...' },
      'course-livestream': {
        title: 'Course livestream',
        table: {
          header: {
            course: 'Course',
            livestream: 'Live stream'
          }
        },
        button: {
          livestream: { label: 'Live' }
        }
      },
      'cource-series': {
        title: 'Course video or audio',
        'department-selector': { hint: 'Select class' },
        hint: 'Please select the class first...',
        table: {
          header: {
            course: 'Course',
            series: 'Video or Audio'
          }
        },
        button: {
          'stream-or-download': { label: 'Stream or Download' }
        }
      },
      'admission-brochure': {
        title: 'Admission brochure',
        label: {
          objective: 'Purpose and goal',
          'teaching-methods': 'Teaching method',
          'school-system': 'Course duration and course selection regulations',
          'start-date': 'Start date',
          location: 'Class location',
          'register-ways': 'Sign up',
          'register-fee': 'Fee'
        },
        button: {
          register: { label: 'Online Application' }
        },
        message: {
          free: 'Free'
        },
        'department-list': {
          title: 'Course divisions, teachers and teaching hours',
          description: 'There are {class_count} class and {sect_count} sects, totaling {total_count} classes.',
          label: {
            lecturer: 'Tutor',
            date: 'Date',
            time: 'Time',
            livestream: 'Livestream',
            audiovisual: 'Video'
          },
          button: {
            introduction: 'Intro'
          }
        }
      }
    }
  },

  department: {
    detail: {
      label: {
        lecturer: 'Tutor',
        'lecturer-introduction': 'Tutor profile',
        time: 'Time',
        'livestream-and-recording': 'Livestream-and-recording',
        livestream: 'Livestream',
        recording: 'Recording',
        'course-plan': 'Course plan'
      }
    }
  },

  'hwadzan-garden': {
    title: 'Hwadzan Garden',
    detail: {
      title: 'Introduction',
      label: {
        address: 'Address',
        'tel-and-fax': 'Tel/Fax',
        rule: 'Regulations',
        'borrowing-application-form': 'Borrowing Application Form',
        map: 'Map'
      },
      value: {
        address: 'Address: No.9, Dalunwei, Aruo Village, Shenkeng Dist., New Taipei City',
        'tel-and-fax': 'Tel: (02) 2662-9168; Fax: 2664-9241'
      },
      link: {
        'rule-web-ver': 'Web Version',
        'rule-download-ver': 'File Download',
        'borrowing-application-form': 'File Download',
        'illustrated-driving-map': 'Driving Map'
      },
      message: {
        'online-ver': 'Online View',
        'doc-format': 'doc format'
      },
      'photo-list': {
        title: 'Park Photos',
        'buddha-hall': { title: 'Buddha Hall' },
        'plaza': { title: 'Plaza' },
        'corridor': { title: 'Corridor' },
        'outdoor': { title: 'Outdoor' },
        'dining-hall': { title: 'Dining Hall' },
        'admin-center': { title: 'Admin Center' },
        'dormitory': { title: 'Dormitory' }
      },
      // 'photo-alt': {
      //   'buddha-hall-1': 'Huazang Teaching Park Buddha Hall Photo 1',
      //   'buddha-hall-2': 'Huazang Teaching Park Buddha Hall Photo 2',
      //   'buddha-hall-3': 'Huazang Teaching Park Buddha Hall Photo 3',
      //   'plaza-1': 'Huazang Teaching Park Plaza Photo 1',
      //   'plaza-2': 'Huazang Teaching Park Plaza Photo 2',
      //   'corridor-1': 'Huazang Teaching Park Corridor Photo 1',
      //   'corridor-2': 'Huazang Teaching Park Corridor Photo 2',
      //   'outdoor-1': 'Huazang Teaching Park Outdoor Photo 1',
      //   'outdoor-2': 'Huazang Teaching Park Outdoor Photo 2',
      //   'dining-hall-1': 'Huazang Teaching Park Dining Hall Photo',
      //   'admin-center-1': 'Huazang Teaching Park Admin Center Photo',
      //   'dormitory-1': 'Huazang Teaching Park Dormitory Photo'
      // }
    }
  },

  event: {
    title: 'Event',
    list: {
      'latest': {
        title: 'Latest Events',
        message: {
          'no-event-this-year': 'No event in {year}'
        }
      },
      review: {
        title: 'Event Review',
        modal: {
          'sidelight': { title: 'Event Sidelight' }
        },
        message: {
          'no-event-this-year': 'No event records in {year}'
        }
      },
      'year-selector': {
        option: { label: '{year}' }
      },
      table: {
        header: {
          'start-date': 'Start date',
          'end-date': 'End date',
          name: 'Name',
          organizer: 'Organizer',
          leader: 'Instructor',
          registration: 'Register',
          contact: 'Contact information',
          livestream: 'Provide live broadcast',
          sidelight: 'Provide sidelight'
        }
      },
      button: {
        introduction: { label: 'Introduction' },
        registration: { label: 'Registration' },
        register: { label: 'Register' },
        livestream: { label: 'Live' },
        sidelight: { label: 'Browse' },
        'browse-video-or-audio': { label: 'Browse video or audio' }
      },
      message: {
        'please-refer-contact': 'Please refer to contact information',
        'event-ended': 'Event ended',
        'no-event-this-year': 'No event in {year}',
        none: 'None'
      }
    },
    detail: {
      title: 'Introduction',
      registration: {
        title: 'Event registration',
        label: {
          'target-audience': 'Target audience',
          'leader-intro': 'Instructor introduction',
          content: 'Event content',
          'registration-date': 'Registration date',
          'registration-method': 'Registration method',
          'registration-fee': 'Registration fee',
          quota: 'Quota',
          'shuttle-info': 'Shuttle bus',
          'self-check-in-info': 'Self check-in',
          note: 'Note'
        },
        button: {
          'registration-form-download': { label: 'Registration form download' },
          'register': { label: 'Register' },
        }
      },
      livestream: {
        title: 'Event Livestream',
        schedule: {
          title: 'Livestream Schedule',
          'date-selector': { label: 'Date' }
        }
      },
      schedule: {
        table: {
          header: {
            date: 'Date',
            'start-time': 'Start date',
            'end-time': 'End date',
            name: 'Name',
            leader: 'Instructor',
            livestream: 'Livestream'
          }
        },
        button: {
          livestream: { label: 'Live' }
        },
        message: {
          none: 'None'
        }
      },
      handout: {
        list: {
          title: 'Handout electronic file download'
        }
      },
      label: {
        name: 'Name',
        'start-date': 'Start date',
        'end-date': 'End date',
        venue: 'Venue'
      },
      button: {
        'view-more': { label: 'View more events' }
      }
    }
  },

  resource: 'Resource',

  book: {
    title: 'Book',
    list: {
      application: {
        title: 'Apply',
        link: {
          'master-list-download': 'Master List Download'
        }
      },
      download: { title: 'Download' },
      search: {
        title: 'Search',
        'search-bar': {
          label: 'Inquiry',
          'keyword-inputor': { hint: 'Please enter keywords' },
          'search-button': { label: 'Search' }
        },
        message: {
          'no-result': 'No results matching the keyword were found'
        }
      },
      label: {
        'selected-language': 'Currently selected'
      },
      modal: {
        'next-page-notice': {
          title: 'Notice',
          message: 'There are more pages available.'
        }
      }
    },
    detail: {
      title: 'Introduction',
      list: {
        efile: {
          heading: 'Electronic file'
        }
      },
      button: {
        'view-more': { label: 'View more books' }
      }
    },
    'efile-list': {
      title: 'Electronic file',
      table: {
        header: {
          format: 'Format',
          name: 'Name',
          size: 'Size',
          date: 'Date',
          pages: 'Pages'
        }
      },
      label: {
        'upload-date': 'Upload Date',
        'updated-date': 'Updated Date'
      },
      message: {
        'no-efile': 'No electronic file available for download'
      }
    },
    button: {
      'size-cm-conversion': { label: 'Format and cm conversion' },
      introduction: { label: 'Introduction' },
      application: {
        label: {
          'in-stock': 'Apply',
          'out-of-stock': 'Out of stock'
        }
      },
      download: { label: 'Download' }
    }
  },

  'lendable-book': {
    title: 'Library Collection',
    list: {
      label: {
        'registration-number': 'Registration No.',
        'call-number': 'Call No.'
      },
      button: {
        introduction: { label: 'Detail' }
      },
      modal: {
        'library-collection-inquiry-notice': {
          title: 'Library Collection Inquiry Notice',
          message: {
            'cannot-provide-borrow-and-return-services': 'This system is only for querying the existing library books of the Association, and cannot provide "online borrow and return" services.',
            'borrow-in-person': 'To borrow books, please visit the service desk on the 3rd floor of the Association.',
            'includes-books-that-are-borrowed-but-not-returned-and-lost': 'Due to the open-shelf borrowing model, the collection catalog includes books that are "borrowed but not returned" and "lost".'
          }
        }
      }
    },
    detail: {
      title: 'Library Collection Detail',
      table: {
        header: {
          'registration-number': 'Registration No.',
          'call-number': 'Call No.',
          publisher: 'Publisher',
          'publication-year': 'Publication Year',
          edition: 'Edition',
          'material-type': 'Material Type',
          binding: 'Binding',
          'collection-location': 'Location',
          'shelf-number': 'Shelf No.',
          isbn: 'ISBN'
        }
      }
    },
    // 新增搜尋列佔位文字
    'search-bar': {
      placeholder: 'Enter keywords'
    }
  },

  series: {
    title: 'Video and audio',
    list: {
      title: 'Video or audio',
      latest: {
        title: 'Latest series',
        button: {
          introduction: { label: 'Introduction' }
        }
      },
      'recently-updated': {
        title: 'Recent Updates',
        ongoing: {
          title: 'Regular Updates',
          button: { 'watch-latest-episode': { label: 'Watch the latest episode' } },
          label: { 'updated-date': 'Updated Date' }
        },
        'recently-added': {
          title: 'Recently Added',
          button: { 'watch-first-episode': { label: 'Watch the first episode' } },
          label: { 'added-date': 'Added Date' }
        },
        updated: {
          title: 'Occasional Updates',
          button: { 'watch-latest-episode': { label: 'Watch the latest episode' } },
          label: { 'updated-date': 'Updated Date' }
        }
      },
      classified: {
        title: 'Classified',
        'category-selector': { hint: 'Select category' },
        label: { 'selected-category': 'Currently selected' }
      },
      search: {
        title: 'Search',
        'search-bar': {
          'keyword-inputor': { hint: 'Please enter keywords' },
          'search-button': { label: 'Search' }
        },
        message: {
          'no-result': 'No results matching the keyword were found'
        }
      },
      button: {
        introduction: { label: 'Introduction' }
      }
    },
    detail: {
      title: 'Introduction',
      label: {
        lecturer: 'Lecturer',
        'start-date': 'Start Date'
      },
      list: {
        handout: {
          heading: 'Handout',
          label: { 'updated-date': 'Updated date' },
          button: {
            download: { label: 'Download' }
          }
        },
        episode: {
          heading: 'Episode',
          label: { 'updated-date': 'Updated date' },
          button: {
            stream: { label: 'Stream' },
            download: { label: 'Download' }
          }
        }
      }
    },
    'livestream-list': {
      title: 'Live stream',
      today: { title: 'Today\'s Livestream' },
      all: { title: 'All Livestream' },
      table: {
        header: {
          time: 'Time',
          course: 'Course',
          lecturer: 'Lecturer',
          'start-date': 'Start Date',
          livestream: 'Live stream',
          remark: 'Note'
        }
      },
      button: {
        livestream: { label: 'Live' }
      },
      message: {
        'have-not-started-yet': 'Have not started yet'
      }
    },
    'episode-efile-list': {
      heading: {
        video: 'Video',
        audio: 'Audio'
      },
      message: {
        'video-file-is-in-rm-format': 'The video file of this episode is in rm format.<br>If you cannot play the file, you can <a class="btn btn-outline-primary  btn-sm" href="https://www.real.com/" target="_blank">Download RealPlayer</a> to play it.'
      }
    },
  },

  picture: {
    title: 'Picture',
    list: {
      application: {
        title: 'Apply',
        link: {
          'master-list-download': 'Master List Download'
        }
      },
      download: { title: 'Download' },
      search: {
        title: 'Search',
        'search-bar': {
          label: 'Inquiry',
          'keyword-inputor': { hint: 'Please enter keywords' },
          'search-button': { label: 'Search' }
        },
        message: {
          'no-result': 'No results matching the keyword were found'
        }
      }
    },
    detail: {
      title: 'Introduction',
      list: {
        efile: {
          heading: 'Electronic file'
        }
      },
      button: {
        'view-more': { label: 'View more Buddha statues and cards' }
      }
    },
    'efile-list': {
      title: 'Electronic file',
      label: {
        downloadable: 'Picture',
        printable: 'Print'
      },
      message: {
        'no-efile': 'No electronic file available for download'
      }
    },
    button: {
      introduction: { label: 'Introduction' },
      application: {
        label: {
          'in-stock': 'Apply',
          'out-of-stock': 'Out of stock'
        }
      },
      download: { label: 'Download' }
    }
  },

  dharma: {
    title: 'Dharma Resource',
    list: {
      latest: {
        title: 'Latest Dharma Books',
        button: {
          introduction: { label: 'Introduction' }
        }
      },
      application: {
        title: 'Apply',
        link: {
          'master-list-download': 'Master List Download'
        }
      },
      download: { title: 'Download' },
      book: {
        title: 'Book',
        label: {
          'selected-language': 'Currently selected'
        }
      },
      picture: { title: 'Picture' },
      search: {
        title: 'Search',
        'type-selector': {
          label: 'Search type',
          option: {
            book: { label: 'Book' },
            picture: { label: 'Picture' }
          }
        },
        'keyword-inputor': { hint: 'Please enter keywords' },
        button: {
          search: { label: 'Search' }
        },
        message: {
          'no-result': 'No results matching the keyword were found'
        }
      },
      modal: {
        'next-page-notice': {
          title: 'Notice',
          message: 'There are more pages available.'
        }
      }
    },
    detail: {
      title: 'Introduction'
    }
  },

  'buddhist-dictionary': {
    title: 'Buddhist Dictionary Tool'
  },

  animation: {
    title: 'Buddha educational animation',
  },

  compassion: {
    title: 'Love life and EP'
  },

  'life-caring-article': 'Life Caring Article',
  'life-caring-monthly-calendar': 'Life Caring Monthly Calendar',
  'life-caring-picture': 'Life Caring Picture',

  search: {
    title: 'Search',
    'type-selector': {
      label: 'Search type',
      option: {
        book: { label: 'Book' },
        picture: { label: 'Picture' },
        series: { label: 'Video or audio' },
        lendable_book: { label: 'Library Collection Inquiry' }
      }
    },
    'category-selector': {
      label: 'Category',
      button: {
        clear: { label: 'Clear' }
      }
    },
    'keyword-inputor': { hint: 'Please enter keywords' },
    button: {
      search: { label: 'Search' }
    },
    message: {
      'no-result': 'No results matching the keyword were found'
    }
  },

  partner: 'Partner Site',

  amtb: {
    title: 'AMTB Website'
  },

  'other-website': {
    title: 'Other Website',
    list: {
      'traditional-chinese': {
        title: 'Traditional Chinese Website'
      },
      'simplified-chinese': {
        title: 'Simplified Chinese Website'
      }
    }
  },

  lang: 'Languages...',

  'book-language-selector-button': {
    label: 'Select language',
    modal: {
      'book-language-selector': {
        title: 'Select language'
      }
    }
  },

  'series-category-selector-button': {
    label: 'Select category',
    modal: {
      'series-category-selector': {
        title: 'Select category'
      }
    }
  },

  'social-sharing-button-toolbar': {
    label: {
      share: 'Share'
    }
  },

  'application-list-button-toolbar': {
    button: {
      display: { label: 'Application List' },
      send: { label: 'Send' }
    },
    modal: {
      'application-list-confirm-send-message': {
        title: 'Confirm to send',
        content: 'Please kindly confirm the application list is correct again before you send it！',
        button: {
          yes: { label: 'YES' },
          no: { label: 'NO' }
        }
      }
    }
  },

  'audiovisual-player': {
    audio: { title: 'Audio' },
    video: { title: 'Video' },
    message: {
      'unsupported-format': [
        'The video content of this series is not available for online playback at this time,',
        'Please download the file to play.'
      ]
    }
  },

  'size-cm-conversion-table': {
    title: 'Format and centimeter conversion table',
    table: {
      header: {
        format: 'Format',
        centimeter: 'Centimeter'
      }
    }
  },

  'weekly-subscription-form': {
    title: 'Subscribe or unsubscribe buddha education weekly',
    label: {
      email: 'Email',
      'subscribe-or-unsubscribe': 'Would you like to:'
    },
    'subscribe-or-unsubscribe-radio-button': {
      option: {
        subscribe: { label: 'Subscribe buddha education weekly' },
        unsubscribe: { label: 'Unsubscribe buddha education weekly' }
      }
    },
    message: {
      'subscription-completed': 'Your subscription has been successfully completed.',
      'unsubscription-completed': 'Your unsubscription has been successfully completed.',
    }
  },

  'dharma-application-form': {
    title: 'Dharma application',
    'application-summary': {
      'instruction-text': {
        'check-and-confirm': 'This is a confirmation page. Please review your application carefully. If there are any errors, you can modify them directly. Once confirmed, please submit again.',
        'change-application-items': 'To change application items, please give up your application and re-fill out the application form.',
        'china-mainland-application-notice': 'When shipping to Mainland China, please be sure to fill in your real name that matches your ID to prevent delivery failure.'
      },
      modal: {
        'china-mainland-application-notice': {
          title: 'Mainland China Application Notice',
          button: {
            ok: { label: 'Confirmed' }
          }
        }
      },
      button: {
        'give-up': { label: 'Give up<br>application' }
      }
    },
    'application-list': {
      title: 'Application list',
      label: {
        quantity: 'Quantity',
        purpose: 'Reason or purpose of the application for Dharma Books',
        purpose_detail: 'Detailed description of the applying purpose for Dharma Books'
      },
      badge: {
        'in-stock': 'In stock',
        'out-of-stock': 'Out of stock',
        'advanced-book': 'Advanced-level Book',
        'scroll-picture': 'Scroll of a Buddha Statue'
      },
      'instruction-text': {
        purpose: 'A brief explanation of the purpose or reason for requesting the scriptures and Dharma items is required for our reference if your application meets any of the following conditions:<ul style="padding-left: 2em"><li style="list-style-type:disc">The total number of books exceeds five (5) copies/sets.</li><li style="list-style-type:disc">The number of advanced-level books reaches one (1) copy/set or more.</li><li style="list-style-type:disc">The number of scrolls of Buddha statues reaches one (1) item or more.</li></ul>',
        purpose_detail: 'If the applying quantity exceeds 50 copies of Dharma books, please kindly provide us with a more detailed purpose description.'
      },
      'error-message': {
        items: {
          required: 'Please add the item to the application list before submitting the application',
          'quantity-not-less-than-one': 'The number of applications cannot be less than 1',
          'item-out-of-stock': 'The application item contains items that are out of stock and cannot be applied for. Please remove the item before submitting the application.'
        },
        purpose: {
          required: 'The purpose or reason for applying for dharma material has not been filled in'
        },
        purpose_detail: {
          required: 'Detailed purpose description is not filled in'
        }
      },
      button: {
        remove: { label: 'Remove' }
      }
    },
    applicant: {
      title: 'Applicant information',
      'type-selector': {
        label: 'Application type',
        hint: 'Please select application type',
        option: {
          individual: { label: 'Individual application' },
          group: { label: 'Group application' },
          proxy: { label: 'Apply on behalf of other groups' }
        }
      },
      'error-message': {
        type: { required: 'Application type not selected' }
      },
      delivery: {
        title: 'Shipping and delivery',
        label: {
          area: 'Delivery area',
          'customs-duty-option': 'Customs duty option',
          'shipping-cost-option': 'Shipping cost option',
          'shipping-cost-option-description': 'Please explain the reason',
          object: 'Receiving method',
          'postal-code': 'Postal code',
          address: 'Delivery address：',
          city: 'Province, State',
          district: 'City, District',
          'street-address': 'Street address',
          'cvs-code': 'Cvs code(FamilyMart convenience stores only)',
          'nearest-available-port': 'Nearest Available Port',
          'can-clear-customs': 'Please kindly make sure that your esteemed Monastery/Organization can clear customs and pick up all the Dharma books from the Port Custom Authority without any problem！'
        },
        'area-selector': { hint: 'Please select delivery area' },
        'customs-duty-option-selector': { hint: 'Please select customs duty method' },
        'shipping-cost-option-selector': { hint: 'Please select the shipping cost method' },
        'object-selector': {
          hint: 'Please select a receiving method',
          option: {
            applicant: 'Home Delivery',
            agent: 'Pick up by agent',
            principal: 'Picked up by Principal',
            cvs: 'Convenience Store Pickup(FamilyMart convenience stores only)'
          }
        },
        button: {
          'cvs-code-inquiry': { label: 'Cvs code query' },
          'cvs-code-pickup-service-instructions': { label: 'Cvs-code pickup service instructions' }
        },
        'help-text': {
          address: 'Please fill in the application form in English to facilitate our sending process; The application form can be filled in Chinese, only when the delivery destination is Taiwan, Mainland of China, Hong Kong, Macau or Japan.'
        },
        'instruction-text': {
          'shipping-cost-option-description': 'You selected "Cannot afford shipping costs, etc.", please explain the reason for our reference for sending.',
          'customs-duty-option': 'Notice：<br>If we send a large number of the Dharma books by shipping container, are you able to pay about USD $500 ~ 1000 for the local taxes and other miscellaneous charges to the port customs authority and the forwarding agent in your country?'
        },
        'disclaimer-text': {
          'customs-duty-option': {
            'unable-to-pay': 'Notice：<br>In few countries, like as India, Sri Lanka, Vietnam…..., the post office will ask you to pay the tariffs, the tariffs\' range depends on the weight of the package; A small mail package uncertainly may cost You 1 ～ 20 U.S. Dollars or more according to the local postal rule of your country.<br>If you are not able to pay the tariffs, the Dharma books will be returned to us, hence we regret and only can send few copies (about 1~3 copies) of Dharma books to you.'
          },
          'can_clear_customs': {
            no: 'Notice：<br>If you are not able to clear customs and pick up all the Dharma books from the destination Port Custom Authority, we regret that we only can send you with a small quantity of Dharma books.'
          }
        },
        'reminder-text': {
          city: {
            'can-apply-at-the-counter': 'Reminder: Applicants shipping to the Taipei area can visit our counter to process the application and save on shipping costs.'
          }
        },
        'error-message': {
          object: { required: 'Receiving method not selected' },
          area: { required: 'Delivery area not selected' },
          'postal-code': { required: 'Postal code is not filled in' },
          city: {
            required: 'City is not filled in',
            'some-areas-support-chinese-input': 'When shipping to Taiwan, Mainland China, Hong Kong, Macau or Japan, the city field can be filled in Chinese. For other overseas areas, please fill in the name column in English.'
          },
          district: {
            required: 'District not filled in',
            'some-areas-support-chinese-input': 'When shipping to Taiwan, Mainland China, Hong Kong, Macau or Japan, the district field can be filled in Chinese. For other overseas areas, please fill in the name column in English.'
          },
          'street-address': {
            required: 'Street address is not filled in',
            'some-areas-support-chinese-input': 'When shipping to Taiwan, Mainland China, Hong Kong, Macau or Japan, the street address field can be filled in Chinese. For other overseas areas, please fill in the name column in English.'
          },
          'cvs-code': { required: 'Cvs code is not filled in' },
          'customs-duty-option': { required: 'Customs duty option is not selected' },
          'shipping-cost-option': { required: 'Shipping cost option is not selected' },
          'shipping-cost-option-description': { required: 'The reason for explaining the shipping cost option is not filled in' },
          'nearest-available-port': { required: 'Nearest available port is not filled in' },
          'can-clear-customs': { required: 'Please kindly make sure that your esteemed Monastery/Organization can clear customs and pick up all the Dharma books from the Port Custom Authority without any problem.' }
        },
        option: {
          yes: 'Yes',
          no: 'No'
        }
      },
      contact: {
        title: 'Contact information',
        individual: {
          label: {
            name: 'Name (same as ID card and passport)',
            'group-name': 'Name of Monastery or Organization (official name registered with the Government)',
            email: 'Email',
            phone: 'Phone',
            'mobile-phone': 'Mobile phone',
            tin: 'TIN',
            fax: 'Fax',
            gmail: 'Gmail',
            'official-email': 'Official Email(gmail is not permitted and not accepted)'
          },
          'error-message': {
            name: {
              required: 'Name not filled in',
              'some-areas-support-chinese-input': 'When shipping to Taiwan, Mainland China, Hong Kong, Macau or Japan, the name field can be filled in Chinese. For other overseas areas, please fill in the name column in English.'
            },
            'group-name': {
              required: 'Name of monastery or organization is not filled in',
              'some-areas-support-chinese-input': 'When shipping to Taiwan, Mainland China, Hong Kong, Macau or Japan, the name of monastery or organization field can be filled in Chinese. For other overseas areas, please fill in the name of monastery or organization column in English.'
            },
            email: {
              required: 'Email is not filled in',
              invalid: 'Email format is incorrect'
            },
            phone: { required: 'Phone number is not filled in' },
            'mobile-phone': { required: 'Mobile phone number is not filled in' },
            tin: {
              required: 'TIN is not filled in',
              invalid: 'TIN format is incorrect'
            },
            fax: { required: 'Fax is not filled in' },
            gmail: { required: 'Gmail is not filled in' },
            'official-email': {
              required: 'Official Email is not filled in',
              invalid: 'Official Email format is incorrect'
            }
          }
        },
        group: {
          label: {
            'group-name': 'Name of Monastery or Organization (official name registered with the Government)',
            name: 'Name of contact person (same as ID card and passport)',
            email: 'Contact email',
            phone: 'Contact phone',
            'mobile-phone': 'Contact mobile',
            tin: 'TIN',
            fax: 'Contact Fax',
            gmail: 'Gmail',
            'official-email': 'Official Email(gmail is not permitted and not accepted)'
          },
          'error-message': {
            'group-name': {
              required: 'Name of monastery or organization is not filled in',
              'some-areas-support-chinese-input': 'When shipping to Taiwan, Mainland China, Hong Kong, Macau or Japan, the name of monastery or organization field can be filled in Chinese. For other overseas areas, please fill in the name column in English.'
            },
            name: {
              required: 'Name of contact person is not filled in',
              'some-areas-support-chinese-input': 'When shipping to Taiwan, Mainland China, Hong Kong, Macau or Japan, the name of contact person field can be filled in Chinese. For other overseas areas, please fill in the name column in English.'
            },
            email: {
              required: 'Contact email is not filled in',
              invalid: 'Contact email format is incorrect'
            },
            phone: { required: 'Contact phone number is not filled in' },
            'mobile-phone': { required: 'Contact mobile number is not filled in' },
            tin: {
              required: 'TIN is not filled in',
              invalid: 'TIN format is incorrect'
            },
            fax: { required: 'Contact Fax is not filled in' },
            gmail: { required: 'Gmail is not filled in' },
            'official-email': {
              required: 'Official Email is not filled in',
              invalid: 'Official Email format is incorrect'
            }
          }
        },
        agent: {
          title: 'Agent',
          label: {
            name: 'Name (same as ID card and passport)',
            'group-name': 'Name of Monastery or Organization (official name registered with the Government)',
            email: 'Email',
            phone: 'Phone',
            'mobile-phone': 'Mobile',
            fax: 'Fax',
            gmail: 'Gmail',
            'official-email': 'Official Email(gmail is not permitted and not accepted)'
          },
          'error-message': {
            name: {
              required: 'Name not filled in',
              'some-areas-support-chinese-input': 'When shipping to Taiwan, Mainland China, Hong Kong, Macau or Japan, the name field can be filled in Chinese. For other overseas areas, please fill in the name column in English.'
            },
            'group-name': {
              required: 'Name of monastery or organization is not filled in',
              'some-areas-support-chinese-input': 'When shipping to Taiwan, Mainland China, Hong Kong, Macau or Japan, the name of monastery or organization field can be filled in Chinese. For other overseas areas, please fill in the name column in English.'
            },
            email: {
              required: 'Email is not filled in',
              invalid: 'Email format is incorrect'
            },
            phone: { required: 'Phone number is not filled in' },
            'mobile-phone': { required: 'Mobile number is not filled in' },
            fax: { required: 'Fax is not filled in' },
            gmail: { required: 'Gmail is not filled in' },
            'official-email': {
              required: 'Official Email is not filled in',
              invalid: 'Official Email format is incorrect'
            }
          }
        },
        principal: {
          title: 'Principal',
          label: {
            'group-name': 'Name of Monastery or Organization (official name registered with the Government)',
            name: 'Name of contact person (same as ID card and passport)',
            email: 'Contact email',
            phone: 'Contact phone',
            'mobile-phone': 'Contact mobile',
            tin: 'TIN',
            fax: 'Contact Fax',
            gmail: 'Gmail',
            'official-email': 'Official Email(gmail is not permitted and not accepted)'
          },
          'error-message': {
            'group-name': {
              required: 'Name of monastery or organization is not filled in',
              'some-areas-support-chinese-input': 'When shipping to Taiwan, Mainland China, Hong Kong, Macau or Japan, the name of monastery or organization field can be filled in Chinese. For other overseas areas, please fill in the name column in English.'
            },
            name: {
              required: 'Name of contact person is not filled in',
              'some-areas-support-chinese-input': 'When shipping to Taiwan, Mainland China, Hong Kong, Macau or Japan, the name of contact person field can be filled in Chinese. For other overseas areas, please fill in the name column in English.'
            },
            email: {
              required: 'Contact email is not filled in',
              invalid: 'Contact email format is incorrect'
            },
            phone: { required: 'Contact phone number is not filled in' },
            'mobile-phone': { required: 'Contact mobile number is not filled in' },
            tin: {
              required: 'TIN is not filled in',
              invalid: 'TIN format is incorrect'
            },
            fax: { required: 'Fax is not filled in' },
            gmail: { required: 'Gmail is not filled in' },
            'official-email': {
              required: 'Official Email is not filled in',
              invalid: 'Official Email format is incorrect'
            }
          }
        },
        'help-text': {
          name: {
            'fill-in-chinese-or-english': 'Please fill in the application form in English to facilitate our sending process;The application form can be filled in Chinese, only when the delivery destination is Taiwan, Mainland China, Hong Kong, Macau or Japan',
            'fill-in-the-real-name': 'When shipping to Mainland China, please be sure to fill in your real name that matches your ID to avoid being unable to receive it.'
          },
          'group-name': {
            'fill-in-chinese-or-english': 'Please fill in the application form in English to facilitate our sending process;The application form can be filled in Chinese, only when the delivery destination is Taiwan, Mainland China, Hong Kong, Macau or Japan'
          },
          tin: {
            'need-to-fill-in-for-small-quantity-applications': 'Since the delivery destination is Brazil, the recipient\'s tax number should be indicated on all international merchandise mailing packages sent to this country.',
            'need-to-fill-in-for-large-quantity-applications': 'Since the delivery destinations are Brazil, India, Bhutan, Nepal, and Indonesia, the recipient\'s tax number should be indicated on all international merchandise mail sent to these countries.'
          },
          'strictly-prohibited-for-sale': '*Dharma material are for personal study use only, Sales are strictly prohibited*'
        }
      },
      tax: {
        title: 'Tax Information',
        label: {
          tin: 'Tax ID',
          pan: 'Permanent Account Number (PAN)',
          gstin: 'Goods and Services Tax Identification Number (GSTIN)',
          iec: 'Import Export Code (IEC)'
        },
        'error-message': {
          tin: {
            required: 'Tax ID is not filled in',
            invalid: 'Tax ID format is incorrect'
          },
          pan: { required: 'Permanent Account Number (PAN) is not filled in' },
          gstin: { required: 'Goods and Services Tax Identification Number (GSTIN) is not filled in' },
          iec: { required: 'Import Export Code (IEC) is not filled in' }
        },
        'help-text': {
          tin: {
            'need-to-fill-in': 'Since the shipping area is Brazil, in accordance with Brazilian postal requirements, all types of international commodity mail sent to that country should indicate the recipient\'s TAX ID. <br>1. If the recipient is a natural person, please attach the CPF certificate number: 000.000.000-00<br>2. If the recipient is a juridical person, please attach the CNPJ number: 00.000.000/0000-00'
          }
        }
      }
    },
    message: {
      'already-added-to-application-list': 'Already added to application list.',
      'application-completed': {
        title: 'Application completed',
        content: [
          'You have completed your application',
          'The confirmation letter will be sent to the email address you filled in later. If you have not received it after one day, please contact the following information:',
          'Email:',
          'Phone:',
          'ext.'
        ]
      },
      'application-notice': {
        title: 'Application notice',
        content: [
          [
            'We will make every effort to send Dharma books and Dharma materials to you based on the details of your application and our current stock.',
            'Because our availability resources are limited, and in order to benefit more people through the free Dharma books service fairly and sustainably, we humbly ask that you should refrain from applying excessive copies of Dharma books more than your need.',
            'For processing efficiently, please submit all your requests in a single application rather than splitting them into multiple applications, we regret that the duplicate applications will not be able to deal with.'
          ],
          [
            'Due to the large quantity of applications, it may take more than three months for you to receive the Dharma books.',
            'In order to expedite the process of sending Dharma books, we humbly ask for your kind patience and refraining from sending follow-up emails before you receive the Dharma books.',
            'Please note that all our Dharma Books are strictly for free distribution and must not, under any circumstances, to be sold.'
          ]
        ]
      },
      'application-list-confirm-submit': {
        title: 'Confirm to submit',
        content: 'Please kindly confirm the application list is correct again before you submit！',
        button: {
          yes: { label: 'YES' },
          no: { label: 'NO' }
        }
      },
      'application-list-confirm-send': {
        title: 'Confirm to send',
        content: 'Please kindly confirm the application list is correct again before you send it！',
        button: {
          yes: { label: 'YES' },
          no: { label: 'NO' }
        }
      }
    }
  },

  'college-registration-form': {
    title: 'Buddhist Academy Application Form',
    basic: {
      title: 'Basic Information',
      label: {
        name: 'Name',
        'birth-date': 'Birth Date',
        gender: 'Gender',
        phone: 'Phone',
        'mobile-phone': 'Mobile',
        email: 'Email',
        'line-id': 'Line ID',
        address: 'Mailing Address',
        education: 'Education',
        organization: 'Organization'
      },
      'gender-selector': { hint: 'Please select gender' },
      'education-selector': { hint: 'Please select education' },
      'instruction-text': {
        'phone-required': 'Please provide either "Phone" or "Mobile".'
      }
    },
    study: {
      title: 'Select Courses',
      label: {
        'primary-department': 'Primary Choice',
        'other-departments': 'Elective Departments (Multiple choice)',
        'buddhist-background': 'Buddhist Background',
        'studied-sutras': 'Studied Sutras',
        'favorite-sutras': 'Favorite Sutras',
        expectations: 'Expectations'
      },
      option: {
        gender: {
          male: 'Male',
          female: 'Female'
        }
      },
      'notice-message': {
        'exclusive-limit': 'The selected department is {department}, and elective departments cannot be added.',
        'limit-reached': 'Maximum 3 departments can be selected, limit reached'
      }
    },
    confirm: {
      title: 'Confirm Registration',
      content: 'Please kindly confirm the application list is correct again before you submit！',
      button: {
        yes: { label: 'YES' },
        no: { label: 'NO' }
      }
    },
    success: {
      title: 'Application Submitted',
      message: 'Your application has been successfully submitted. A confirmation email will be sent to your email address. We will process your application as soon as possible.',
    },
    button: {
      'prev-step': { label: 'Previous' },
      'next-step': { label: 'Next' },
      submit: { label: 'Submit Application' },
    }
  },

  'event-registration-form': {
    title: 'Event Registration Form',
    basic: {
      title: 'Basic Info',
      label: {
        name: 'Name',
        gender: 'Gender',
        'birth-date': 'Birth Date',
        education: 'Education',
        occupation: 'Occupation',
        'health-condition': 'Health Condition',
        email: 'Email',
        phone: 'Phone',
        'mobile-phone': 'Mobile',
        address: 'Address',
        'emergency-contact-name': 'Contact Name',
        'emergency-contact-phone': 'Contact Phone',
        'emergency-contact-mobile-phone': 'Contact Mobile',
        'emergency-contact-address': 'Contact Address'
      },
      heading: {
        contact: 'Contact Info',
        'emergency-contact': 'Emergency Contact'
      },
      placeholder: {
        'please-specify': 'Please specify',
      },
      'instruction-text': {
        'phone-required': 'Please provide either "Phone" or "Mobile".'
      }
    },
    detail: {
      title: 'Detail Info',
      heading: {
        'transportation': 'Transportation',
      },
      label: {
        precepts: 'Precepts',
        'full-ordination-date': 'Ordination Date',
        'observing-eight-precepts': 'Observing Eight Precepts',
        skills: 'Skills',
        'volunteer-interest': 'Interested in Volunteering',
        'volunteer-or-staff-role': 'Previous staff or volunteer role',
        'how-heard': 'How did you hear about us?',
        'attended-times': 'Times Attended',
        'transportation-go': 'Outbound',
        'transportation-return': 'Return',
        remarks: 'Remarks',
        agreement: 'Commitment'
      },
      placeholder: {
        'please-specify': 'Please specify',
        'full-ordination-date': 'Select a date',
      },
      'declaration-text': {
        agreement: 'I am willing to comply with all regulations during the event, obey the guidance of the Dharma Master and the resident monks, maintain order, and avoid affecting others. If I violate these rules, I agree to accept the handling in accordance with the event regulations and bear the consequences myself.'
      },
      option: {
        precepts: {
          'bodhisattva_none': 'None',
          'bodhisattva_history': 'Previously received',
          'bodhisattva_times': 'times Bodhisattva Precepts',
        },
        agreement: {
          agree: 'I agree',
          disagree: 'I disagree'
        }
      }
    },
    confirm: {
      title: 'Confirm & Submit',
      content: 'Please kindly confirm the application list is correct again before you submit！',
      button: {
        yes: { label: '是' },
        no: { label: '否' }
      }
    },
    success: {
      title: 'Application Submitted',
      message: 'Your application has been successfully submitted. A confirmation email will be sent to your email address. We will process your application as soon as possible.'
    },
    button: {
      'prev-step': { label: 'Previous' },
      'next-step': { label: 'Next' },
      submit: { label: 'Submit Registration' },
    },

    'photo': 'Photo Upload',
    'photo_hint': 'Please upload a recent photo (supports jpg, png formats)'
  },

  modal: {
    button: {
      'continue-browsing': { label: 'Continue<br>Browsing' },
      'close': { label: 'Close' },
      'cancel': { label: 'Cancel' },
      'submit': { label: 'Submit' },
      'submitting': { label: 'Submitting...' },
      'complete': { label: 'Complete' },
      'ok': { label: 'OK' }
    }
  },

  paginator: {
    'items-per-page-selector': {
      option: { label: '{size} items per page' }
    }
  },

  issue: 'Issue {issue}',

  frequency: {
    weekly: 'Every',
    'weeks-of-month': {
      first: 'The 1st week of the month',
      second: 'The 2nd week of the month',
      third: 'The 3rd week of the month',
      fourth: 'The 4th week of the month',
      fifth: 'The 5th week of the month'
    },
    'week-intervals': {
      one: 'Every two weeks',
      two: 'Every three weeks',
      three: 'Every four weeks',
      four: 'Every five weeks',
      five: 'Every six weeks'
    }
  },

  'days-of-week': {
    sunday: { full: 'Sunday', abbr: 'Sun' },
    monday: { full: 'Monday', abbr: 'Mon' },
    tuesday: { full: 'Tuesday', abbr: 'Tue' },
    wednesday: { full: 'Wednesday', abbr: 'Wed' },
    thursday: { full: 'Thursday', abbr: 'Thu' },
    friday: { full: 'Friday', abbr: 'Fri' },
    saturday: { full: 'Saturday', abbr: 'Sat' }
  }
}
